import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { PageSpinner } from '../components/common/LoadingSpinner';
import { takeReturnTo } from '../utils/returnTo';

function SSOCallback() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, refreshUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    // Back to the page that asked for sign-in, else the dashboard. Read the saved page once only,
    // so a re-run of this effect (StrictMode, auth state changing) can't send the user elsewhere.
    const finish = () => {
      if (done.current) return;
      done.current = true;
      navigate(takeReturnTo() ?? '/dashboard');
    };

    const handleCallback = async () => {
      if (isLoading) return;
      
      if (isAuthenticated) {
        finish();
      } else {
        // Try to refresh user from cookie
        try {
          await refreshUser();
          finish();
        } catch {
          navigate('/login');
        }
      }
    };

    handleCallback();
  }, [isAuthenticated, isLoading, navigate, refreshUser]);

  return <PageSpinner text="Completing login..." />;
}

export default SSOCallback;